module.exports = __webpack_public_path__ + "img/图层 13.bdb6c5e6.png";